var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/global.28ab2604b3e01ee6a5f79b69829afa28.svg#backspace';
                    var viewUrl = 'svg/global.28ab2604b3e01ee6a5f79b69829afa28.svg#view-backspace';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 27.289 20',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };